import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  button: {
    marginRight: theme.spacing(1)
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  formButtonsContainer: {
    marginLeft: 'auto',
    width: 'fit-content',
    marginTop: 32
  },
  stepsContentContainer: {
    width: '80%',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}))

export default useStyles
